import React, { useState, useEffect } from "react";
import { useAuth } from "../context/AuthContext";

const UserProfileForm = () => {
  const { user, refreshChatData, refreshUserData, validateEcode } = useAuth();
  const [formData, setFormData] = useState({
    name: user?.name || "",
    v_mail: user?.v_mail || "",
    location: user?.location || "",
    country: user?.country || "",
    currency: user?.currency || "",
    ga_design: user?.ga_design || "",
    mail_design: user?.mail_design || "",
    tf_button: user?.tf_button || "",
    order_btn: user?.order_btn || "",
    barcode: user?.barcode || "",
    map_box: user?.map_box || "",
  });
  const [loading, setLoading] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await fetch(
        "https://kracet.shop/mastapi/updateuser.php",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        }
      );

      const result = await response.json();

      if (result.success) {
        alert("User profile updated successfully!");
        refreshUserData();
        refreshChatData();
        validateEcode();
      } else {
        alert("Update failed: " + result.message);
      }
    } catch (error) {
      console.error("Error:", error);
      alert("An error occurred while updating the profile.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (user) {
      setFormData({
        name: user?.name || "",
        v_mail: user?.v_mail || "",
        location: user?.location || "",
        country: user?.country || "",
        currency: user?.currency || "",
        ga_design: user?.ga_design || "",
        mail_design: user?.mail_design || "",
        tf_button: user?.tf_button || "",
        map_box: user?.map_box || "",
        order_btn: user?.order_btn || "",
        barcode: user?.barcode || "",
        chat_id: user?.chat_id,
      });
    }
  }, [user]);

  return (
    <div className="px-2 mt-4 pb-2 border-b-4 border-blue-950 border-dotted">
      <form onSubmit={handleSubmit}>
        <div className="flex justify-between gap-2">
          <div>
            <p className="text-lg font-semibold">Name</p>
            <input
              type="text"
              name="name"
              placeholder="Name Here"
              className="w-full mb-4 p-2 border border-black rounded"
              value={formData.name}
              onChange={handleInputChange}
              disabled={loading}
            />
          </div>
          <div>
            <p className="text-lg font-semibold">Virtual Mail</p>
            <input
              type="email"
              name="v_mail"
              placeholder="virtualmail"
              className="w-full mb-4 p-2 border border-black rounded"
              value={formData.v_mail}
              onChange={handleInputChange}
              disabled={loading}
            />
          </div>
        </div>
        <div className="flex justify-between gap-2">
          <div>
            <p className="text-lg font-semibold">City & State</p>
            <input
              type="text"
              name="location"
              className="w-full mb-4 p-2 border border-black rounded"
              value={formData.location}
              required
              onChange={handleInputChange}
              disabled={loading}
            />
          </div>
          <div>
            <p className="text-lg font-semibold">Country</p>
            <input
              type="text"
              name="country"
              placeholder="country"
              className="w-full mb-4 p-2 border border-black rounded"
              value={formData.country}
              required
              onChange={handleInputChange}
              disabled={loading}
            />
          </div>
        </div>
        <div className="flex justify-around">
          <div>
            <p className="text-lg font-semibold">Currency</p>
            <select
              name="currency"
              className="w-full mb-4 p-2 border border-black rounded"
              value={formData.currency}
              onChange={handleInputChange}
              disabled={loading}
            >
              <option value="€">€ (euro)</option>
              <option value="$">$ (dollar)</option>
              <option value="£">£ (pounds)</option>
            </select>
          </div>

          <div>
            <p className="text-lg font-semibold">GA Design</p>
            <select
              name="ga_design"
              className="w-full mb-4 p-2 border border-black rounded"
              value={formData.ga_design}
              onChange={handleInputChange}
              disabled={loading}
            >
              <option value="D1">D1 (US)</option>
              <option value="D2">D2 (other)</option>
            </select>
          </div>

          <div>
            <p className="text-lg font-semibold">Mail Design</p>
            <select
              name="mail_design"
              className="w-full mb-4 p-2 border border-black rounded"
              value={formData.mail_design}
              onChange={handleInputChange}
              disabled={loading}
            >
              <option value="D1">D1 (US)</option>
              <option value="D2">D2 (other)</option>
            </select>
          </div>
        </div>
        <div className="flex justify-around">
          <div>
            <p className="text-lg font-semibold">Transfer BTN</p>
            <select
              name="tf_button"
              className="w-full mb-4 p-2 border border-black rounded"
              value={formData.tf_button}
              onChange={handleInputChange}
              disabled={loading}
            >
              <option value="yes">yes</option>
              <option value="no">no</option>
            </select>
          </div>

          <div>
            <p className="text-lg font-semibold">Map View</p>
            <select
              name="map_box"
              className="w-full mb-4 p-2 border border-black rounded"
              value={formData.map_box}
              onChange={handleInputChange}
              disabled={loading}
            >
              <option value="yes">yes</option>
              <option value="no">no</option>
            </select>
          </div>

          <div>
            <p className="text-lg font-semibold">Order BTN</p>
            <select
              name="order_btn"
              className="w-full mb-4 p-2 border border-black rounded"
              value={formData.order_btn}
              onChange={handleInputChange}
              disabled={loading}
            >
              <option value="yes">yes</option>
              <option value="no">no</option>
            </select>
          </div>
        </div>
        <div className="mb-2">
          <div className="flex justify-center items-center gap-4">
            <div className="">
              <p className="text-lg font-semibold">Barcode View</p>
              <select
                name="barcode"
                className="w-full mb-4 p-2 border border-black rounded"
                value={formData.barcode}
                onChange={handleInputChange}
                disabled={loading}
              >
                <option value="yes">yes</option>
                <option value="no">no</option>
              </select>
            </div>

            <div className="">
              <button
                className="border text-white bg-green-700 rounded-md py-2 px-8 flex items-center gap-2"
                type="submit"
                disabled={loading}
              >
                {loading ? (
                  <svg
                    className="animate-spin h-5 w-5 text-white"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <circle
                      className="opacity-25"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      strokeWidth="4"
                    ></circle>
                    <path
                      className="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
                    ></path>
                  </svg>
                ) : (
                  "Update"
                )}
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};

export default UserProfileForm;
